import { a4 as e, a as t, M as n, m as r, U as i, a9 as a, g as s, e as o, u, i as c, ay as l, _ as d, A as h, ab as p, f, h as m, b as v, am as y, c as g, S as _, V as T, W as U, az as I, aA as w, Q as M, aa as E, ac as b, aB as S, aC as P, aw as C, au as A, a8 as D, p as R, a1 as q, a5 as O, K as L, a2 as N, ad as F, t as k, ae as Q, aj as z, ai as x, z as G, aD as V, ar as j, a0 as B, r as W, s as K, af as H, aE as Y } from "./__bundle-75942676.js";
import { d as J, A as X, U as Z, F as $, R as ee, T as te, e as ne, f as re, b as ie, c as ae, g as se, h as oe, i as ue, v as ce, j as le, k as de, B as he, S as pe } from "./__bundle-84f74e8d.js";
import { i as fe, P as me, a as ve, b as ye } from "./__bundle-ad161b2c.js";
var ge,
  _e = 100,
  Te = "GroupChannel",
  Ue = "url",
  Ie = 100,
  we = "Message",
  Me = "messageId",
  Ee = "Poll",
  be = "pollId",
  Se = {
    data: void 0,
    customType: void 0,
    mentionType: e.USERS,
    mentionedUserIds: void 0,
    mentionedUsers: void 0,
    mentionedMessageTemplate: void 0,
    metaArrays: void 0,
    parentMessageId: void 0,
    isReplyToChannel: !1,
    pushNotificationDeliveryOption: void 0,
    appleCriticalAlertOptions: void 0,
    isPinnedMessage: !1
  },
  Pe = function Pe(s) {
    return t("string", s.data, !0) && t("string", s.customType, !0) && n(e, s.mentionType) && r("string", s.mentionedUserIds, !0) && r(i, s.mentionedUsers, !0) && t("string", s.mentionedMessageTemplate, !0) && r(J, s.metaArrays, !0) && t("number", s.parentMessageId, !0) && t("boolean", s.isReplyToChannel) && n(a, s.pushNotificationDeliveryOption, !0) && t(X, s.appleCriticalAlertOptions, !0) && t("boolean", s.isPinnedMessage, !0);
  },
  Ce = function Ce(e) {
    return {
      isReplyToChannel: e.isReplyToChannel,
      pushNotificationDeliveryOption: e.pushNotificationDeliveryOption,
      pollId: e.pollId
    };
  },
  Ae = s(s({}, Se), {
    message: "",
    translationTargetLanguages: void 0,
    pollId: void 0
  }),
  De = function De(e) {
    return Pe(e) && t("string", e.message) && r("string", e.translationTargetLanguages, !0) && t("number", e.pollId, !0);
  };
!function (e) {
  e.FILE = "file", e.BLOB = "blob", e.BLOB_LIKE_OBJECT = "blobLikeObject", e.URL = "url";
}(ge || (ge = {}));
var Re,
  qe = function qe(e) {
    return "undefined" != typeof window && "Blob" in window && "undefined" != typeof Blob && e instanceof Blob;
  },
  Oe = function Oe(e) {
    return e === ge.BLOB || e === ge.FILE;
  },
  Le = function Le(e) {
    return {
      file: e.file,
      fileKey: e.fileKey,
      fileType: e.fileType,
      isReplyToChannel: e.isReplyToChannel,
      pushNotificationDeliveryOption: e.pushNotificationDeliveryOption
    };
  },
  Ne = s(s({}, Se), {
    file: void 0,
    fileKey: void 0,
    fileUrl: void 0,
    fileName: void 0,
    fileType: void 0,
    fileSize: void 0,
    mimeType: void 0,
    thumbnailSizes: void 0,
    requireAuth: !1
  }),
  Fe = function Fe(e) {
    return Pe(e) && (c(e.file) || t("string", e.fileUrl)) && t("string", e.fileName, !0) && t("string", e.mimeType, !0) && t("number", e.fileSize, !0) && (null === e.thumbnailSizes || void 0 === e.thumbnailSizes || Array.isArray(e.thumbnailSizes) && e.thumbnailSizes.every(function (e) {
      return t("object", e) && e.maxWidth > 0 && e.maxHeight > 0;
    }));
  },
  ke = function ke(e) {
    return o({
      fileInfoList: e.fileInfoList,
      isReplyToChannel: e.isReplyToChannel,
      pushNotificationDeliveryOption: e.pushNotificationDeliveryOption
    });
  },
  Qe = s(s({}, Se), {
    fileInfoList: []
  }),
  ze = function ze(e) {
    return (c(e.file) || t("string", e.fileUrl)) && t("string", e.fileName, !0) && t("string", e.mimeType, !0) && t("number", e.fileSize, !0) && (void 0 === e.thumbnailSizes || Array.isArray(e.thumbnailSizes) && e.thumbnailSizes.every(function (e) {
      return e.maxWidth > 0 && e.maxHeight > 0;
    }));
  };
!function (e) {
  e.MUTED = "muted", e.BANNED = "banned";
}(Re || (Re = {}));
var xe,
  Ge = function () {
    function e(e) {
      var t, r, i, a;
      this.restrictionType = null, n(Re, e.restriction_type) && (this.restrictionType = e.restriction_type), this.description = null !== (t = e.description) && void 0 !== t ? t : null, this.endAt = null !== (i = null !== (r = e.end_at) && void 0 !== r ? r : e.muted_end_at) && void 0 !== i ? i : -1, this.remainingDuration = null !== (a = e.remaining_duration) && void 0 !== a ? a : -1;
    }
    return e.payloadify = function (e) {
      return o(u({
        restriction_type: e.restrictionType,
        description: e.description,
        end_at: e.endAt,
        remaining_duration: e.remainingDuration
      }));
    }, e;
  }(),
  Ve = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.restrictionInfo = new Ge(n), r;
    }
    return d(t, e), t.payloadify = function (t) {
      return o(u(s(s({}, e.payloadify.call(this, t)), Ge.payloadify(t.restrictionInfo))));
    }, t;
  }(i),
  je = {
    data: void 0,
    customType: void 0,
    mentionType: e.USERS,
    mentionedUserIds: void 0,
    mentionedUsers: void 0,
    mentionedMessageTemplate: void 0,
    metaArrays: void 0,
    pushNotificationDeliveryOption: void 0,
    appleCriticalAlertOptions: void 0
  },
  Be = function Be(s) {
    return t("string", s.data, !0) && t("string", s.customType, !0) && n(e, s.mentionType) && r("string", s.mentionedUserIds, !0) && r(i, s.mentionedUsers, !0) && t("string", s.mentionedMessageTemplate, !0) && r(J, s.metaArrays, !0) && n(a, s.pushNotificationDeliveryOption, !0) && t(X, s.appleCriticalAlertOptions, !0);
  },
  We = s(s({}, je), {
    message: void 0,
    translationTargetLanguages: void 0,
    pollId: void 0
  }),
  Ke = function Ke(e) {
    return Be(e) && t("string", e.message, !0) && r("string", e.translationTargetLanguages, !0) && t("number", e.pollId, !0);
  },
  He = s({}, je),
  Ye = function (e) {
    function t(t) {
      var n = t.channelUrl,
        r = t.channelType,
        i = t.token,
        a = t.limit,
        s = e.call(this) || this;
      return s.method = h.GET, s.path = "".concat(p(r), "/").concat(encodeURIComponent(n), "/operators"), s.params = {
        token: i,
        limit: a
      }, s;
    }
    return d(t, e), t;
  }(f),
  Je = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.operators = n.operators.map(function (e) {
        return new i(t, e);
      }), r.token = n.next, r;
    }
    return d(t, e), t;
  }(m),
  Xe = function (e) {
    function t(t, n, r, i) {
      return e.call(this, t, n, r, i) || this;
    }
    return d(t, e), t.prototype._validate = function () {
      return e.prototype._validate.call(this);
    }, t.prototype.next = function () {
      return v(this, void 0, void 0, function () {
        var e, t, n, r, i, a, o;
        return g(this, function (u) {
          switch (u.label) {
            case 0:
              return this._validate() ? this._isLoading ? [3, 3] : (e = [], this._hasNext ? (this._isLoading = !0, t = T.of(this._iid).requestQueue, n = new Ye(s(s({}, this), {
                channelUrl: this.channelUrl,
                token: this._token
              })), [4, t.send(n)]) : [3, 2]) : [3, 5];
            case 1:
              return r = u.sent(), i = r.as(Je), a = i.operators, o = i.token, this._token = o, this._hasNext = !!o, this._isLoading = !1, [2, a];
            case 2:
              return [2, e];
            case 3:
              throw _.queryInProgress;
            case 4:
              return [3, 6];
            case 5:
              throw _.invalidParameters;
            case 6:
              return [2];
          }
        });
      });
    }, t;
  }(y),
  Ze = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.limit,
        s = t.token;
      return (n = e.call(this) || this).method = h.GET, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/mute"), n.params = {
        limit: a,
        token: s
      }, n;
    }
    return d(t, e), t;
  }(f),
  $e = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      r.mutedUsers = [];
      var i = n.next,
        a = n.muted_list;
      return r.token = i, a && a.length > 0 && (r.mutedUsers = a.map(function (e) {
        return new Ve(t, e);
      })), r;
    }
    return d(t, e), t;
  }(m),
  et = function (e) {
    function t(t, n, r, i) {
      return e.call(this, t, n, r, i) || this;
    }
    return d(t, e), t.prototype.next = function () {
      return v(this, void 0, void 0, function () {
        var e, t, n, r, i, a;
        return g(this, function (o) {
          switch (o.label) {
            case 0:
              return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = T.of(this._iid).requestQueue, t = new Ze(s(s({}, this), {
                token: this._token
              })), [4, e.send(t)]) : [3, 2] : [3, 5];
            case 1:
              return n = o.sent(), r = n.as($e), i = r.mutedUsers, a = r.token, this._token = a, this._hasNext = !!a, this._isLoading = !1, [2, i];
            case 2:
              return [2, []];
            case 3:
              throw _.queryInProgress;
            case 4:
              return [3, 6];
            case 5:
              throw _.invalidParameters;
            case 6:
              return [2];
          }
        });
      });
    }, t;
  }(y),
  tt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.limit,
        s = t.token;
      return (n = e.call(this) || this).method = h.GET, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/ban"), n.params = o({
        limit: a,
        token: s
      }), n;
    }
    return d(t, e), t;
  }(f),
  nt = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      r.bannedUsers = [];
      var i = n.next,
        a = n.banned_list;
      return r.token = i, a && a.length > 0 && (r.bannedUsers = a.map(function (e) {
        return new Ve(t, e.user);
      })), r;
    }
    return d(t, e), t;
  }(m),
  rt = function (e) {
    function t(t, n, r, i) {
      return e.call(this, t, n, r, i) || this;
    }
    return d(t, e), t.prototype._validate = function () {
      return e.prototype._validate.call(this);
    }, t.prototype.next = function () {
      return v(this, void 0, void 0, function () {
        var e, t, n, r, i, a;
        return g(this, function (o) {
          switch (o.label) {
            case 0:
              return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = T.of(this._iid).requestQueue, t = new tt(s(s({}, this), {
                token: this._token
              })), [4, e.send(t)]) : [3, 2] : [3, 5];
            case 1:
              return n = o.sent(), r = n.as(nt), i = r.bannedUsers, a = r.token, this._token = a, this._hasNext = !!a, this._isLoading = !1, [2, i];
            case 2:
              return [2, []];
            case 3:
              throw _.queryInProgress;
            case 4:
              return [3, 6];
            case 5:
              throw _.invalidParameters;
            case 6:
              return [2];
          }
        });
      });
    }, t;
  }(y);
!function (e) {
  e.SPAM = "spam", e.HARASSING = "harassing", e.SUSPICIOUS = "suspicious", e.INAPPROPRIATE = "inappropriate";
}(xe || (xe = {}));
var it = function (e) {
  function t(t) {
    var n = this,
      r = t.channelUrl,
      i = t.channelType,
      a = t.operatorUserIds;
    return (n = e.call(this) || this).method = h.POST, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/operators"), n.params = {
      operator_ids: a
    }, n;
  }
  return d(t, e), t;
}(f);
!function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }
  d(t, e);
}(m);
var at = function (e) {
  function t(t) {
    var n = this,
      r = t.channelUrl,
      i = t.channelType,
      a = t.operatorUserIds;
    return (n = e.call(this) || this).method = h.DELETE, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/operators"), n.params = {
      operator_ids: a
    }, n;
  }
  return d(t, e), t;
}(f);
!function (e) {
  function t(t, n) {
    return e.call(this, t, n) || this;
  }
  d(t, e);
}(m);
var st = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.userId;
      return (n = e.call(this) || this).method = h.GET, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/mute/").concat(a), n;
    }
    return d(t, e), t;
  }(f),
  ot = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      r.isMuted = !1, r.startAt = 0, r.endAt = 0;
      var i = n.is_muted,
        a = n.start_at,
        s = n.end_at,
        o = n.remaining_duration,
        u = n.description;
      return r.isMuted = i, r.startAt = a, r.endAt = s, r.remainingDuration = o, r.description = u, r;
    }
    return d(t, e), t;
  }(m),
  ut = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.keys;
      return (n = e.call(this) || this).method = h.GET, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/metadata"), n.params = {
        keys: a,
        include_ts: !0
      }, n;
    }
    return d(t, e), t;
  }(f),
  ct = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this,
        i = n.metadata,
        a = n.ts;
      return r.metadata = i, r.ts = a, r;
    }
    return d(t, e), t;
  }(m),
  lt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.metadata;
      return (n = e.call(this) || this).method = h.POST, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/metadata"), n.params = {
        metadata: a,
        include_ts: !0
      }, n;
    }
    return d(t, e), t;
  }(f),
  dt = function (e) {
    function t(t, n) {
      var r,
        i,
        a = this;
      return (a = e.call(this, t, n) || this).metaData = null !== (r = n.metadata) && void 0 !== r ? r : {}, a.ts = null !== (i = n.ts) && void 0 !== i ? i : null, a;
    }
    return d(t, e), t;
  }(m),
  ht = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.metadata,
        s = t.upsert;
      return (n = e.call(this) || this).method = h.PUT, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/metadata"), n.params = {
        metadata: a,
        include_ts: !0,
        upsert: null != s && s
      }, n;
    }
    return d(t, e), t;
  }(f),
  pt = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this,
        i = n.metadata,
        a = n.ts;
      return r.metadata = i, r.ts = a, r;
    }
    return d(t, e), t;
  }(m),
  ft = function (e) {
    function t(t, n, r) {
      var i = e.call(this, t, "SYEV", r) || this;
      return r.data && (i.created = r.data.created, i.updated = r.data.updated, i.deleted = r.data.deleted), i;
    }
    return d(t, e), t;
  }(U),
  mt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.key;
      return (n = e.call(this) || this).method = h.DELETE, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/metadata/").concat(a), n.params = {
        include_ts: !0
      }, n;
    }
    return d(t, e), t;
  }(f),
  vt = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this,
        i = n.ts;
      return r.ts = i, r;
    }
    return d(t, e), t;
  }(m),
  yt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType;
      return (n = e.call(this) || this).method = h.DELETE, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/metadata"), n.params = {
        include_ts: !0
      }, n;
    }
    return d(t, e), t;
  }(f),
  gt = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this,
        i = n.ts;
      return r.ts = i, r;
    }
    return d(t, e), t;
  }(m),
  _t = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.keys;
      return (n = e.call(this) || this).method = h.GET, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/metacounter"), n.params = {
        keys: a
      }, n;
    }
    return d(t, e), t;
  }(f),
  Tt = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.metaCounter = n, r;
    }
    return d(t, e), t;
  }(m),
  Ut = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.metaCounter;
      return (n = e.call(this) || this).method = h.POST, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/metacounter"), n.params = {
        metacounter: a
      }, n;
    }
    return d(t, e), t;
  }(f),
  It = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.metaCounter = n, r;
    }
    return d(t, e), t;
  }(m),
  wt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.metaCounter,
        s = t.upsert,
        o = void 0 !== s && s,
        u = t.mode,
        c = void 0 === u ? "set" : u;
      return (n = e.call(this) || this).method = h.PUT, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/metacounter"), n.params = {
        metacounter: a,
        upsert: o,
        mode: c
      }, n;
    }
    return d(t, e), t;
  }(f),
  Mt = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.metaCounter = n, r;
    }
    return d(t, e), t;
  }(m),
  Et = function (e) {
    function t(t, n, r) {
      var i = e.call(this, t, "SYEV", r) || this;
      return r.data && (i.created = r.data.created, i.updated = r.data.updated, i.deleted = r.data.deleted), i;
    }
    return d(t, e), t;
  }(U),
  bt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.key;
      return (n = e.call(this) || this).method = h.DELETE, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/metacounter/").concat(a), n.params = {}, n;
    }
    return d(t, e), t;
  }(f);
!function (e) {
  function t(t, n) {
    return e.call(this, t, n) || this;
  }
  d(t, e);
}(m);
var St = function (e) {
  function t(t) {
    var n = this,
      r = t.channelUrl,
      i = t.channelType;
    return (n = e.call(this) || this).method = h.DELETE, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/metacounter"), n.params = {}, n;
  }
  return d(t, e), t;
}(f);
!function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }
  d(t, e);
}(m);
var Pt = function (e) {
  function t(t) {
    var n = this,
      r = t.channelUrl,
      i = t.channelType,
      a = t.userId,
      s = t.seconds,
      o = t.description;
    return (n = e.call(this) || this).method = h.POST, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/mute"), n.params = {
      user_id: a,
      seconds: s,
      description: o
    }, n;
  }
  return d(t, e), t;
}(f);
!function (e) {
  function t(t, n) {
    return e.call(this, t, n) || this;
  }
  d(t, e);
}(m);
var Ct = function (e) {
    function t(t, n, r) {
      var i = e.call(this, t, "SYEV", r) || this;
      return i.user = new Ve(t, r.data), i;
    }
    return d(t, e), t;
  }(U),
  At = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.userId;
      return (n = e.call(this) || this).method = h.DELETE, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/mute/").concat(encodeURIComponent(a)), n;
    }
    return d(t, e), t;
  }(f);
!function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }
  d(t, e);
}(m);
var Dt = function (e) {
    function t(t, n, r) {
      var i = e.call(this, t, "SYEV", r) || this;
      return i.user = new Ve(t, r.data), i;
    }
    return d(t, e), t;
  }(U),
  Rt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.userId,
        s = t.seconds,
        u = t.description;
      return (n = e.call(this) || this).method = h.POST, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/ban"), n.params = o({
        user_id: a,
        seconds: s,
        description: u
      }), n;
    }
    return d(t, e), t;
  }(f);
!function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }
  d(t, e);
}(m);
var qt = function (e) {
    function t(t, n, r) {
      var i = e.call(this, t, "SYEV", r) || this;
      return i.user = new Ve(t, r.data), r.data.member_count && (i.memberCount = r.data.member_count), r.data.joined_member_count && (i.joinedMemberCount = r.data.joined_member_count), i;
    }
    return d(t, e), t;
  }(U),
  Ot = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.userId;
      return (n = e.call(this) || this).method = h.DELETE, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/ban/").concat(encodeURIComponent(a)), n;
    }
    return d(t, e), t;
  }(f);
!function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }
  d(t, e);
}(m);
var Lt = function (e) {
    function t(t, n, r) {
      var i = e.call(this, t, "SYEV", r) || this;
      return i.user = new Ve(t, r.data), i;
    }
    return d(t, e), t;
  }(U),
  Nt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.freezing;
      return (n = e.call(this) || this).method = h.PUT, n.path = "".concat(p(i), "/").concat(encodeURIComponent(r), "/freeze"), n.params = {
        freeze: a
      }, n;
    }
    return d(t, e), t;
  }(f);
!function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }
  d(t, e);
}(m);
var Ft = function (e) {
    function t(t, n, r) {
      var i = e.call(this, t, "SYEV", r) || this;
      return i.freeze = r.data.freeze, i;
    }
    return d(t, e), t;
  }(U),
  kt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.category,
        s = t.userId,
        o = t.description;
      return (n = e.call(this) || this).method = h.POST, n.path = "".concat(I(i), "/").concat(encodeURIComponent(r)), n.params = {
        report_category: a,
        reporting_user_id: s,
        report_description: o
      }, n;
    }
    return d(t, e), t;
  }(f),
  Qt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.category,
        s = t.userId,
        o = t.offendingUserId,
        u = t.description;
      return (n = e.call(this) || this).method = h.POST, n.path = "".concat(w, "/users/").concat(o), n.params = {
        channel_url: r,
        channel_type: i === M.OPEN ? "open_channels" : "group_channels",
        report_category: a,
        reporting_user_id: s,
        report_description: u
      }, n;
    }
    return d(t, e), t;
  }(f),
  zt = function (e) {
    function t(t) {
      var n = this,
        r = t.channelUrl,
        i = t.channelType,
        a = t.category,
        s = t.userId,
        o = t.offendingUserId,
        u = t.messageId,
        c = t.description;
      return (n = e.call(this) || this).method = h.POST, n.path = "".concat(I(i), "/").concat(encodeURIComponent(r), "/messages/").concat(u), n.params = {
        report_category: a,
        reporting_user_id: s,
        report_description: c,
        offending_user_id: o
      }, n;
    }
    return d(t, e), t;
  }(f),
  xt = function (t) {
    function n(n) {
      var r = [];
      return n.mentionType === e.USERS && (n.mentionedUserIds ? r = n.mentionedUserIds : n.mentionedUsers && (r = n.mentionedUsers.map(function (e) {
        return e.userId;
      }))), t.call(this, {
        code: "MESG",
        ackRequired: !0,
        payload: o(u({
          channel_url: n.channelUrl,
          message: n.message,
          data: n.data,
          custom_type: n.customType,
          metaarray: n.metaArrays,
          mention_type: n.mentionType,
          mentioned_user_ids: r,
          mentioned_message_template: n.mentionedMessageTemplate,
          target_langs: n.translationTargetLanguages,
          push_option: n.pushNotificationDeliveryOption && n.pushNotificationDeliveryOption !== a.DEFAULT ? n.pushNotificationDeliveryOption : void 0,
          apple_critical_alert_options: n.appleCriticalAlertOptions,
          silent: n.silent,
          reply_to_channel: n.isReplyToChannel,
          parent_message_id: n.parentMessageId ? n.parentMessageId : null,
          req_id: n.reqId,
          poll_id: n.pollId,
          pin_message: n.isPinnedMessage
        }))
      }) || this;
    }
    return d(n, t), n;
  }(E),
  Gt = function (e) {
    function t(t, n, r) {
      var i,
        a,
        s,
        o,
        u = this;
      (u = e.call(this, t, "MESG", r) || this).message = new Z(t, r);
      var c = T.of(t).sdkState;
      return u.isMentioned = b(u.message.mentionType, null !== (s = null !== (i = u.message.mentionedUserIds) && void 0 !== i ? i : null === (a = u.message.mentionedUsers) || void 0 === a ? void 0 : a.map(function (e) {
        return e.userId;
      })) && void 0 !== s ? s : [], c.userId), u.forceUpdateLastMessage = null !== (o = r.force_update_last_message) && void 0 !== o && o, u;
    }
    return d(t, e), t;
  }(U),
  Vt = function (t) {
    function n(n) {
      var r = null;
      return n.mentionType === e.USERS && (n.mentionedUserIds ? r = n.mentionedUserIds : n.mentionedUsers && (r = n.mentionedUsers.map(function (e) {
        return e.userId;
      }))), t.call(this, {
        code: "MEDI",
        ackRequired: !0,
        payload: o(u({
          channel_url: n.channelUrl,
          msg_id: n.messageId,
          message: n.message,
          data: n.data,
          custom_type: n.customType,
          metaarray: n.metaArrayParams,
          mention_type: n.mentionType,
          mentioned_user_ids: r,
          mentioned_message_template: n.mentionedMessageTemplate,
          apple_critical_alert_options: n.appleCriticalAlertOptions ? X.payloadify(n.appleCriticalAlertOptions) : null,
          poll_id: n.pollId
        }))
      }) || this;
    }
    return d(n, t), n;
  }(E),
  jt = function (e) {
    function t(t, n, r) {
      var i,
        a,
        s,
        o,
        c,
        l = this;
      (l = e.call(this, t, "MEDI", r) || this).message = new Z(t, r);
      var d = T.of(t).sdkState;
      return l.mentionCountChange = S({
        mentionType: null === (i = r.old_values) || void 0 === i ? void 0 : i.mention_type,
        mentionedUserIds: null !== (s = null === (a = r.old_values) || void 0 === a ? void 0 : a.mentioned_user_ids) && void 0 !== s ? s : []
      }, u({
        mentionType: l.message.mentionType,
        mentionedUserIds: null !== (o = l.message.mentionedUserIds) && void 0 !== o ? o : null === (c = l.message.mentionedUsers) || void 0 === c ? void 0 : c.map(function (e) {
          return e.userId;
        })
      }), d.userId), l;
    }
    return d(t, e), t;
  }(U),
  Bt = function (t) {
    function n(n) {
      var r = null;
      return n.mentionType === e.USERS && (n.mentionedUserIds ? r = n.mentionedUserIds : n.mentionedUsers && (r = n.mentionedUsers.map(function (e) {
        return e.userId;
      }))), t.call(this, {
        code: "FEDI",
        ackRequired: !0,
        payload: o(u({
          channel_url: n.channelUrl,
          msg_id: n.messageId,
          data: n.data,
          custom_type: n.customType,
          metaarray: n.metaArrayParams,
          mention_type: n.mentionType,
          mentioned_user_ids: r,
          apple_critical_alert_options: n.appleCriticalAlertOptions
        }))
      }) || this;
    }
    return d(n, t), n;
  }(E),
  Wt = function (e) {
    function t(t, n, r) {
      var i,
        a,
        s,
        o,
        c,
        l = this;
      (l = e.call(this, t, "FEDI", r) || this).message = new $(t, r);
      var d = T.of(t).sdkState;
      return l.mentionCountChange = S({
        mentionType: null === (i = r.old_values) || void 0 === i ? void 0 : i.mention_type,
        mentionedUserIds: null !== (s = null === (a = r.old_values) || void 0 === a ? void 0 : a.mentioned_user_ids) && void 0 !== s ? s : []
      }, u({
        mentionType: l.message.mentionType,
        mentionedUserIds: null !== (o = l.message.mentionedUserIds) && void 0 !== o ? o : null === (c = l.message.mentionedUsers) || void 0 === c ? void 0 : c.map(function (e) {
          return e.userId;
        })
      }), d.userId), l;
    }
    return d(t, e), t;
  }(U),
  Kt = function (e) {
    function t(t) {
      var n = e.call(this) || this;
      return n.method = h.DELETE, n.path = "".concat(p(t.channelType), "/").concat(t.channelUrl, "/messages/").concat(t.messageId), n;
    }
    return d(t, e), t;
  }(f);
!function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }
  d(t, e);
}(m);
var Ht = function (e) {
    function t(t, n, r) {
      var i = e.call(this, t, "DELM", r) || this;
      return i.channelUrl = r.channel_url, i.channelType = r.channel_type, i.messageId = Number(r.msg_id), i;
    }
    return d(t, e), t;
  }(U),
  Yt = function (e) {
    function t(t) {
      var n = t.channelType,
        r = t.channelUrl,
        i = t.messageId,
        a = t.reactionKey,
        s = e.call(this) || this;
      return s.method = h.POST, s.path = "".concat(p(n), "/").concat(encodeURIComponent(r), "/messages/").concat(i, "/reactions"), s.params = {
        reaction: a
      }, s;
    }
    return d(t, e), t;
  }(f),
  Jt = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.reactionEvent = new ee(n), r;
    }
    return d(t, e), t;
  }(m),
  Xt = function (e) {
    function t(t) {
      var n = t.channelType,
        r = t.channelUrl,
        i = t.messageId,
        a = t.reactionKey,
        s = e.call(this) || this;
      return s.method = h.DELETE, s.path = "".concat(p(n), "/").concat(encodeURIComponent(r), "/messages/").concat(i, "/reactions"), s.params = {
        reaction: a
      }, s;
    }
    return d(t, e), t;
  }(f),
  Zt = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.reactionEvent = new ee(s({}, n)), r;
    }
    return d(t, e), t;
  }(m),
  $t = function (e) {
    function t(t) {
      var n = t.channelType,
        r = t.channelUrl,
        i = t.messageId,
        a = t.translationTargetLanguages,
        s = e.call(this) || this;
      return s.method = h.POST, s.path = "".concat(p(n), "/").concat(encodeURIComponent(r), "/messages/").concat(encodeURIComponent(i), "/translation"), s.params = {
        target_langs: a
      }, s;
    }
    return d(t, e), t;
  }(f),
  en = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.message = new Z(t, n), r;
    }
    return d(t, e), t;
  }(m),
  tn = function (t) {
    function n(n) {
      var r,
        i = this;
      i = t.call(this) || this;
      var a = [];
      n.mentionType === e.USERS && (n.mentionedUserIds ? a = n.mentionedUserIds : n.mentionedUsers && (a = n.mentionedUsers.map(function (e) {
        return e.userId;
      })));
      var s = n.channelType,
        c = n.channelUrl;
      return i.method = h.POST, i.path = "".concat(p(s), "/").concat(encodeURIComponent(c), "/scheduled_messages"), i.params = o(u({
        req_id: n.reqId,
        scheduled_at: n.scheduledAt,
        message_type: P.USER,
        message: n.message,
        custom_type: n.customType,
        data: n.data,
        mention_type: n.mentionType,
        mentioned_user_ids: a,
        sorted_metaarray: null === (r = n.metaArrays) || void 0 === r ? void 0 : r.map(function (e) {
          return J.payloadify(e);
        }),
        apple_critical_alert_options: n.appleCriticalAlertOptions ? X.payloadify(n.appleCriticalAlertOptions) : null,
        target_langs: n.translationTargetLanguages,
        push_option: n.pushNotificationDeliveryOption
      })), i;
    }
    return d(n, t), n;
  }(f),
  nn = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.message = new Z(t, n), r;
    }
    return d(t, e), t;
  }(m),
  rn = function (t) {
    function n(n) {
      var r,
        i = this;
      i = t.call(this) || this;
      var a = [];
      n.mentionType === e.USERS && (n.mentionedUserIds ? a = n.mentionedUserIds : n.mentionedUsers && (a = n.mentionedUsers.map(function (e) {
        return e.userId;
      })));
      var s = n.channelType,
        o = n.channelUrl;
      return i.method = h.POST, i.path = "".concat(p(s), "/").concat(encodeURIComponent(o), "/scheduled_messages"), i.params = u({
        req_id: n.reqId,
        scheduled_at: n.scheduledAt,
        message_type: P.FILE,
        url: n.fileUrl,
        file_name: n.fileName,
        file_size: n.fileSize,
        file_type: n.mimeType,
        thumbnails: n.thumbnailSizes ? n.thumbnailSizes.map(function (e) {
          return te.payloadify(e);
        }) : [],
        custom_type: n.customType,
        data: n.data,
        require_auth: n.requireAuth,
        mention_type: n.mentionType,
        mentioned_user_ids: a,
        sorted_metaarray: null === (r = n.metaArrays) || void 0 === r ? void 0 : r.map(function (e) {
          return J.payloadify(e);
        }),
        apple_critical_alert_options: n.appleCriticalAlertOptions ? X.payloadify(n.appleCriticalAlertOptions) : null,
        push_option: n.pushNotificationDeliveryOption
      }), i;
    }
    return d(n, t), n;
  }(f),
  an = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.message = new $(t, n), r;
    }
    return d(t, e), t;
  }(m),
  sn = function (e) {
    function t(t) {
      var n = t.pollId,
        r = t.title,
        i = t.data,
        a = t.allowUserSuggestion,
        s = t.allowMultipleVotes,
        o = t.closeAt,
        u = e.call(this) || this;
      return u.method = h.PUT, u.path = "".concat(A, "/").concat(encodeURIComponent(n)), u.params = {
        title: r,
        data: i,
        allow_user_suggestion: a,
        allow_multiple_votes: s,
        close_at: o
      }, u;
    }
    return d(t, e), t;
  }(f),
  on = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.poll = new D(t, n), r;
    }
    return d(t, e), t;
  }(m),
  un = function (e) {
    function t(t) {
      var n = t.pollId,
        r = e.call(this) || this;
      return r.method = h.DELETE, r.path = "".concat(A, "/").concat(encodeURIComponent(n)), r;
    }
    return d(t, e), t;
  }(f);
!function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }
  d(t, e);
}(m);
var cn = function (e) {
    function t(t) {
      var n = t.pollId,
        r = e.call(this) || this;
      return r.method = h.PUT, r.path = "".concat(A, "/").concat(encodeURIComponent(n), "/close"), r;
    }
    return d(t, e), t;
  }(f),
  ln = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.poll = new D(t, n), r;
    }
    return d(t, e), t;
  }(m),
  dn = function (e) {
    function t(t) {
      var n = t.channelUrl,
        r = t.channelType,
        i = t.pollId,
        a = t.optionText,
        s = e.call(this) || this;
      return s.method = h.POST, s.path = "".concat(A, "/").concat(encodeURIComponent(i), "/options"), s.params = {
        channel_url: n,
        channel_type: r,
        text: a
      }, s;
    }
    return d(t, e), t;
  }(f),
  hn = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.poll = new D(t, n), r;
    }
    return d(t, e), t;
  }(m),
  pn = function (e) {
    function t(t) {
      var n = t.pollId,
        r = t.pollOptionId,
        i = t.optionText,
        a = e.call(this) || this;
      return a.method = h.PUT, a.path = "".concat(A, "/").concat(encodeURIComponent(n), "/options/").concat(encodeURIComponent(r)), a.params = {
        text: i
      }, a;
    }
    return d(t, e), t;
  }(f),
  fn = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this;
      return r.poll = new D(t, n), r;
    }
    return d(t, e), t;
  }(m),
  mn = function (e) {
    function t(t) {
      var n = t.pollId,
        r = t.pollOptionId,
        i = e.call(this) || this;
      return i.method = h.DELETE, i.path = "".concat(A, "/").concat(encodeURIComponent(n), "/options/").concat(encodeURIComponent(r)), i;
    }
    return d(t, e), t;
  }(f);
!function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }
  d(t, e);
}(m);
var vn = function (e) {
    function t(t) {
      var n = t.reqId,
        r = t.channelType,
        i = t.channelUrl,
        a = t.pollId,
        s = t.pollOptionIds;
      return e.call(this, {
        code: "VOTE",
        ackRequired: !0,
        payload: o({
          req_id: n,
          channel_type: r === M.OPEN ? "open_channels" : "group_channels",
          channel_url: i,
          poll_id: a,
          option_ids: s
        })
      }) || this;
    }
    return d(t, e), t;
  }(E),
  yn = function (e) {
    function t(t, n, r) {
      var i = e.call(this, t, "VOTE", r) || this;
      return i.event = new fe(r), i.channelUrl = r.channel_url, i.channelType = r.channel_type, i;
    }
    return d(t, e), t;
  }(U),
  gn = 2,
  _n = function (e) {
    function h(n, r) {
      var a,
        s,
        o,
        u,
        c = this;
      return (c = e.call(this, n) || this).channelType = M.BASE, c.name = "", c.coverUrl = "", c.customType = "", c.data = "", c.isFrozen = !1, c.isEphemeral = !1, c.creator = null, c.createdAt = 0, c._messageCollectionLastAccessedAt = 0, c.url = r.channel_url, c.name = null !== (a = r.name) && void 0 !== a ? a : "", c.coverUrl = null !== (s = r.cover_url) && void 0 !== s ? s : "", c.customType = null !== (o = r.custom_type) && void 0 !== o ? o : "", c.data = null !== (u = r.data) && void 0 !== u ? u : "", c.isFrozen = !!t("boolean", r.freeze) && r.freeze, c.isEphemeral = !!t("boolean", r.is_ephemeral) && r.is_ephemeral, c.creator = r.created_by ? new i(c._iid, r.created_by) : null, c.createdAt = 1e3 * r.created_at, r.metadata && Object.keys(r.metadata).length > 0 && r.ts && (c._cachedMetaData = new Map(), Object.keys(r.metadata).forEach(function (e) {
        c._cachedMetaData.set(e, {
          value: r.metadata[e],
          isRemoved: !1,
          updatedAt: r.ts
        });
      })), c;
    }
    return d(h, e), h.payloadify = function (t) {
      return o(u(s(s({}, e.payloadify.call(this, t)), {
        channel_url: t.url,
        name: t.name,
        cover_url: t.coverUrl,
        custom_type: t.customType,
        data: t.data,
        freeze: t.isFrozen,
        is_ephemeral: t.isEphemeral,
        created_by: t.creator ? i.payloadify(t.creator) : null,
        created_at: t.createdAt / 1e3
      })));
    }, h.prototype.isGroupChannel = function () {
      return this.channelType === M.GROUP;
    }, h.prototype.isOpenChannel = function () {
      return this.channelType === M.OPEN;
    }, Object.defineProperty(h.prototype, "cachedMetaData", {
      get: function get() {
        var e = {};
        return this._cachedMetaData ? (this._cachedMetaData.forEach(function (t, n) {
          t.isRemoved || (e[n] = t.value);
        }), e) : e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(h.prototype, "messageCollectionLastAccessedAt", {
      get: function get() {
        return this._messageCollectionLastAccessedAt;
      },
      enumerable: !1,
      configurable: !0
    }), h.prototype._updateMessageCollectionLastAccessedAt = function () {
      this._messageCollectionLastAccessedAt = Date.now();
    }, h.prototype._update = function (e) {
      var t = o(e);
      Object.assign(this, t);
    }, h.prototype._upsertCachedMetaData = function (e, t) {
      var n = this;
      Object.keys(e).forEach(function (r) {
        n._cachedMetaData || (n._cachedMetaData = new Map());
        var i = n._cachedMetaData.get(r);
        (!i || i.updatedAt <= t) && n._cachedMetaData.set(r, {
          value: e[r],
          isRemoved: !1,
          updatedAt: t
        });
      });
    }, h.prototype._removeFromCachedMetaData = function (e, t) {
      var n = this;
      this._cachedMetaData && e.forEach(function (e) {
        var r = n._cachedMetaData.get(e);
        r && r.updatedAt < t && (r.isRemoved = !0, r.updatedAt = t);
      });
    }, h.prototype._generateRequestId = function () {
      return "rq-".concat(R());
    }, h.prototype.isIdentical = function (e) {
      return e && this.url === e.url;
    }, h.prototype.isEqual = function (e) {
      return q(this, e);
    }, h.prototype.createOperatorListQuery = function (e) {
      return void 0 === e && (e = {}), new Xe(this._iid, this.url, this.channelType, e);
    }, h.prototype.createMutedUserListQuery = function (e) {
      return void 0 === e && (e = {}), new et(this._iid, this.url, this.channelType, e);
    }, h.prototype.createBannedUserListQuery = function (e) {
      return void 0 === e && (e = {}), new rt(this._iid, this.url, this.channelType, e);
    }, h.prototype.createPreviousMessageListQuery = function (e) {
      return void 0 === e && (e = {}), new ne(this._iid, this.url, this.channelType, e);
    }, h.prototype.addOperators = function (e) {
      return v(this, void 0, void 0, function () {
        var t, n;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return k(r("string", e)).throw(_.invalidParameters), t = T.of(this._iid).requestQueue, n = new it({
                channelUrl: this.url,
                channelType: this.channelType,
                operatorUserIds: e
              }), [4, t.send(n)];
            case 1:
              return i.sent(), [2];
          }
        });
      });
    }, h.prototype.removeOperators = function (e) {
      return v(this, void 0, void 0, function () {
        var t, n;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return k(r("string", e)).throw(_.invalidParameters), t = T.of(this._iid).requestQueue, n = new at({
                channelUrl: this.url,
                channelType: this.channelType,
                operatorUserIds: e
              }), [4, t.send(n)];
            case 1:
              return i.sent(), [2];
          }
        });
      });
    }, h.prototype.getMyMutedInfo = function () {
      return v(this, void 0, void 0, function () {
        var e, t, n, r, i, a, s, o, u, c, l;
        return g(this, function (d) {
          switch (d.label) {
            case 0:
              return e = T.of(this._iid), t = e.sdkState, n = e.requestQueue, r = new st({
                channelUrl: this.url,
                channelType: this.channelType,
                userId: t.userId
              }), [4, n.send(r)];
            case 1:
              return i = d.sent(), a = i.as(ot), s = a.isMuted, o = a.startAt, u = a.endAt, c = a.remainingDuration, l = a.description, [2, {
                isMuted: s,
                startAt: o,
                endAt: u,
                remainingDuration: c,
                description: l
              }];
          }
        });
      });
    }, h.prototype.getMetaData = function (e) {
      return v(this, void 0, void 0, function () {
        var t, n, i, a, s, o;
        return g(this, function (u) {
          switch (u.label) {
            case 0:
              return k(r("string", e)).throw(_.invalidParameters), t = T.of(this._iid).requestQueue, n = new ut({
                channelUrl: this.url,
                channelType: this.channelType,
                keys: e
              }), [4, t.send(n)];
            case 1:
              return i = u.sent(), a = i.as(ct), s = a.metadata, o = a.ts, this._upsertCachedMetaData(s, o), [2, s];
          }
        });
      });
    }, h.prototype.getAllMetaData = function () {
      return v(this, void 0, void 0, function () {
        var e, t, n, r, i, a;
        return g(this, function (s) {
          switch (s.label) {
            case 0:
              return e = T.of(this._iid).requestQueue, t = new ut({
                channelUrl: this.url,
                channelType: this.channelType,
                keys: []
              }), [4, e.send(t)];
            case 1:
              return n = s.sent(), r = n.as(ct), i = r.metadata, a = r.ts, this._upsertCachedMetaData(i, a), [2, i];
          }
        });
      });
    }, h.prototype.createMetaData = function (e) {
      return v(this, void 0, void 0, function () {
        var t, n, r, i;
        return g(this, function (a) {
          switch (a.label) {
            case 0:
              return t = T.of(this._iid).requestQueue, n = new lt({
                channelUrl: this.url,
                channelType: this.channelType,
                metadata: e
              }), [4, t.send(n)];
            case 1:
              return r = a.sent(), i = r.as(dt).metaData, this._upsertCachedMetaData(i, 0), [2, i];
          }
        });
      });
    }, h.prototype.updateMetaData = function (e, t) {
      return void 0 === t && (t = !1), v(this, void 0, void 0, function () {
        var n, r, i, a, s, o;
        return g(this, function (u) {
          switch (u.label) {
            case 0:
              return n = T.of(this._iid).requestQueue, r = new ht({
                channelUrl: this.url,
                channelType: this.channelType,
                metadata: e,
                upsert: t
              }), [4, n.send(r)];
            case 1:
              return i = u.sent(), a = i.as(pt), s = a.metadata, o = a.ts, this._upsertCachedMetaData(s, o), [2, s];
          }
        });
      });
    }, h.prototype.deleteMetaData = function (e) {
      return v(this, void 0, void 0, function () {
        var n, r, i, a;
        return g(this, function (s) {
          switch (s.label) {
            case 0:
              return k(t("string", e)).throw(_.invalidParameters), n = T.of(this._iid).requestQueue, r = new mt({
                channelUrl: this.url,
                channelType: this.channelType,
                key: e
              }), [4, n.send(r)];
            case 1:
              return i = s.sent(), a = i.as(vt).ts, this._removeFromCachedMetaData([e], a), [2];
          }
        });
      });
    }, h.prototype.deleteAllMetaData = function () {
      return v(this, void 0, void 0, function () {
        var e, t, n, r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return e = T.of(this._iid).requestQueue, t = new yt({
                channelUrl: this.url,
                channelType: this.channelType
              }), [4, e.send(t)];
            case 1:
              return n = i.sent(), r = n.as(gt).ts, this._removeFromCachedMetaData(W([], K(this._cachedMetaData.keys()), !1), r), [2];
          }
        });
      });
    }, h.prototype.getMetaCounters = function (e) {
      return v(this, void 0, void 0, function () {
        var t, n, i;
        return g(this, function (a) {
          switch (a.label) {
            case 0:
              return k(r("string", e)).throw(_.invalidParameters), t = T.of(this._iid).requestQueue, n = new _t({
                channelUrl: this.url,
                channelType: this.channelType,
                keys: e
              }), [4, t.send(n)];
            case 1:
              return i = a.sent(), [2, i.as(Tt).metaCounter];
          }
        });
      });
    }, h.prototype.getAllMetaCounters = function () {
      return v(this, void 0, void 0, function () {
        var e, t, n;
        return g(this, function (r) {
          switch (r.label) {
            case 0:
              return e = T.of(this._iid).requestQueue, t = new _t({
                channelUrl: this.url,
                channelType: this.channelType,
                keys: []
              }), [4, e.send(t)];
            case 1:
              return n = r.sent(), [2, n.as(Tt).metaCounter];
          }
        });
      });
    }, h.prototype.createMetaCounters = function (e) {
      return v(this, void 0, void 0, function () {
        var t, n, r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return t = T.of(this._iid).requestQueue, n = new Ut({
                channelUrl: this.url,
                channelType: this.channelType,
                metaCounter: e
              }), [4, t.send(n)];
            case 1:
              return r = i.sent(), [2, r.as(It).metaCounter];
          }
        });
      });
    }, h.prototype.updateMetaCounters = function (e, t) {
      return void 0 === t && (t = !1), v(this, void 0, void 0, function () {
        var n, r, i;
        return g(this, function (a) {
          switch (a.label) {
            case 0:
              return n = T.of(this._iid).requestQueue, r = new wt({
                channelUrl: this.url,
                channelType: this.channelType,
                metaCounter: e,
                upsert: t
              }), [4, n.send(r)];
            case 1:
              return i = a.sent(), [2, i.as(Mt).metaCounter];
          }
        });
      });
    }, h.prototype.increaseMetaCounters = function (e) {
      return v(this, void 0, void 0, function () {
        var t, n, r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return t = T.of(this._iid).requestQueue, n = new wt({
                channelUrl: this.url,
                channelType: this.channelType,
                metaCounter: e,
                upsert: !1,
                mode: "increase"
              }), [4, t.send(n)];
            case 1:
              return r = i.sent(), [2, r.as(Mt).metaCounter];
          }
        });
      });
    }, h.prototype.decreaseMetaCounters = function (e) {
      return v(this, void 0, void 0, function () {
        var t, n, r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return t = T.of(this._iid).requestQueue, n = new wt({
                channelUrl: this.url,
                channelType: this.channelType,
                metaCounter: e,
                upsert: !1,
                mode: "decrease"
              }), [4, t.send(n)];
            case 1:
              return r = i.sent(), [2, r.as(Mt).metaCounter];
          }
        });
      });
    }, h.prototype.deleteMetaCounter = function (e) {
      return v(this, void 0, void 0, function () {
        var n, r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return k(t("string", e)).throw(_.invalidParameters), n = T.of(this._iid).requestQueue, r = new bt({
                channelUrl: this.url,
                channelType: this.channelType,
                key: e
              }), [4, n.send(r)];
            case 1:
              return i.sent(), [2];
          }
        });
      });
    }, h.prototype.deleteAllMetaCounters = function () {
      return v(this, void 0, void 0, function () {
        var e, t;
        return g(this, function (n) {
          switch (n.label) {
            case 0:
              return e = T.of(this._iid).requestQueue, t = new St({
                channelUrl: this.url,
                channelType: this.channelType
              }), [4, e.send(t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, h.prototype.muteUser = function (e, t, n) {
      return v(this, void 0, void 0, function () {
        return g(this, function (r) {
          return [2, this.muteUserWithUserId(e.userId, t, n)];
        });
      });
    }, h.prototype.muteUserWithUserId = function (e, n, r) {
      return v(this, void 0, void 0, function () {
        var i, a;
        return g(this, function (s) {
          switch (s.label) {
            case 0:
              return k(t("string", e) && t("number", n, !0) && t("string", r, !0)).throw(_.invalidParameters), i = T.of(this._iid).requestQueue, a = new Pt({
                channelUrl: this.url,
                channelType: this.channelType,
                userId: e,
                seconds: n,
                description: r
              }), [4, i.send(a)];
            case 1:
              return s.sent(), [2];
          }
        });
      });
    }, h.prototype.unmuteUser = function (e) {
      return v(this, void 0, void 0, function () {
        return g(this, function (t) {
          return [2, this.unmuteUserWithUserId(e.userId)];
        });
      });
    }, h.prototype.unmuteUserWithUserId = function (e) {
      return v(this, void 0, void 0, function () {
        var n, r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return k(t("string", e)).throw(_.invalidParameters), n = T.of(this._iid).requestQueue, r = new At({
                channelUrl: this.url,
                channelType: this.channelType,
                userId: e
              }), [4, n.send(r)];
            case 1:
              return i.sent(), [2];
          }
        });
      });
    }, h.prototype.banUser = function (e, t, n) {
      return v(this, void 0, void 0, function () {
        return g(this, function (r) {
          return [2, this.banUserWithUserId(e.userId, t, n)];
        });
      });
    }, h.prototype.banUserWithUserId = function (e, n, r) {
      return v(this, void 0, void 0, function () {
        var i, a;
        return g(this, function (s) {
          switch (s.label) {
            case 0:
              return k(t("string", e) && t("number", n, !0) && t("string", r, !0)).throw(_.invalidParameters), i = T.of(this._iid).requestQueue, a = new Rt({
                channelUrl: this.url,
                channelType: this.channelType,
                userId: e,
                seconds: n,
                description: r
              }), [4, i.send(a)];
            case 1:
              return s.sent(), [2];
          }
        });
      });
    }, h.prototype.unbanUser = function (e) {
      return v(this, void 0, void 0, function () {
        return g(this, function (t) {
          return [2, this.unbanUserWithUserId(e.userId)];
        });
      });
    }, h.prototype.unbanUserWithUserId = function (e) {
      return v(this, void 0, void 0, function () {
        var n, r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return k(t("string", e)).throw(_.invalidParameters), n = T.of(this._iid).requestQueue, r = new Ot({
                channelUrl: this.url,
                channelType: this.channelType,
                userId: e
              }), [4, n.send(r)];
            case 1:
              return i.sent(), [2];
          }
        });
      });
    }, h.prototype.freeze = function () {
      return v(this, void 0, void 0, function () {
        var e, t;
        return g(this, function (n) {
          switch (n.label) {
            case 0:
              return e = T.of(this._iid).requestQueue, t = new Nt({
                channelUrl: this.url,
                channelType: this.channelType,
                freezing: !0
              }), [4, e.send(t)];
            case 1:
              return n.sent(), this.isFrozen = !0, [2];
          }
        });
      });
    }, h.prototype.unfreeze = function () {
      return v(this, void 0, void 0, function () {
        var e, t;
        return g(this, function (n) {
          switch (n.label) {
            case 0:
              return e = T.of(this._iid).requestQueue, t = new Nt({
                channelUrl: this.url,
                channelType: this.channelType,
                freezing: !1
              }), [4, e.send(t)];
            case 1:
              return n.sent(), this.isFrozen = !1, [2];
          }
        });
      });
    }, h.prototype.getMessagesByMessageId = function (e, n) {
      return v(this, void 0, void 0, function () {
        var r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return r = s(s({}, ue), n), k(t("number", e) && ce(r)).throw(_.invalidParameters), [4, ae.of(this._iid).getMessagesByMessageId(this.url, this.channelType, e, r)];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, h.prototype.getMessagesByTimestamp = function (e, n) {
      return v(this, void 0, void 0, function () {
        var r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return r = s(s({}, ue), n), k(t("number", e) && ce(r)).throw(_.invalidParameters), [4, ae.of(this._iid).getMessagesByTimestamp(this.url, this.channelType, e, r)];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, h.prototype.getMessageChangeLogsSinceTimestamp = function (e, n) {
      return void 0 === n && (n = {}), v(this, void 0, void 0, function () {
        var r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return r = s(s({}, le), n), k(t("number", e) && de(r)).throw(_.invalidParameters), [4, ae.of(this._iid).getMessageChangelogs(this.url, this.channelType, e, r)];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, h.prototype.getMessageChangeLogsSinceToken = function (e, n) {
      return void 0 === n && (n = {}), v(this, void 0, void 0, function () {
        var r;
        return g(this, function (i) {
          switch (i.label) {
            case 0:
              return r = s(s({}, le), n), k(t("string", e) && de(r)).throw(_.invalidParameters), [4, ae.of(this._iid).getMessageChangelogs(this.url, this.channelType, e, r)];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, h.prototype._createPendingSendableMessagePayload = function (e, t, n) {
      var r,
        a = T.of(this._iid).sessionManager;
      return o(u({
        channel_url: this.url,
        channel_type: this.channelType,
        msg_id: 0,
        parent_message_id: e.parentMessageId,
        data: e.data,
        custom_type: e.customType,
        mention_type: e.mentionType,
        sorted_metaarray: e.metaArrays ? e.metaArrays.map(function (e) {
          return J.payloadify(e);
        }) : null,
        apple_critical_alert_options: e.appleCriticalAlertOptions ? X.payloadify(e.appleCriticalAlertOptions) : null,
        created_at: n,
        user: a.currentUser ? re.payloadify(a.currentUser) : null,
        req_id: t,
        request_state: O.PENDING,
        mentioned_user_ids: e.mentionedUserIds,
        mentioned_users: null === (r = e.mentionedUsers) || void 0 === r ? void 0 : r.map(function (e) {
          return i.payloadify(e);
        })
      }));
    }, h.prototype._createPendingUserMessage = function (e, t, n) {
      var r,
        i,
        a = {};
      if (e.translationTargetLanguages) try {
        for (var u = L(e.translationTargetLanguages), c = u.next(); !c.done; c = u.next()) {
          a[c.value] = "";
        }
      } catch (e) {
        r = {
          error: e
        };
      } finally {
        try {
          c && !c.done && (i = u.return) && i.call(u);
        } finally {
          if (r) throw r.error;
        }
      }
      var l = o(s(s({}, this._createPendingSendableMessagePayload(e, t, n)), {
          type: N.USER,
          message: e.message,
          translations: a
        })),
        d = new Z(this._iid, l);
      return d.messageParams = e, d;
    }, h.prototype._createPendingScheduledUserMessage = function (e, t, n) {
      var r = this._createPendingUserMessage(e, t, n);
      return r.scheduledInfo = {
        scheduledMessageId: 0,
        scheduledAt: e.scheduledAt,
        scheduledMessageParams: e
      }, r;
    }, h.prototype._createPendingFileMessage = function (e, t, n) {
      var r,
        i,
        a,
        u,
        c,
        l,
        d = o(s(s({}, this._createPendingSendableMessagePayload(e, t, n)), {
          type: N.FILE,
          url: e.fileUrl,
          file: {
            name: null !== (r = e.fileName) && void 0 !== r ? r : null === (i = e.file) || void 0 === i ? void 0 : i.name,
            size: null !== (a = e.fileSize) && void 0 !== a ? a : null === (u = e.file) || void 0 === u ? void 0 : u.size,
            type: null !== (c = e.mimeType) && void 0 !== c ? c : null === (l = e.file) || void 0 === l ? void 0 : l.type,
            data: e.data
          },
          thumbnails: e.thumbnailSizes ? e.thumbnailSizes.map(function (e) {
            return {
              url: "",
              width: e.maxWidth,
              height: e.maxHeight
            };
          }) : []
        })),
        h = new $(this._iid, d);
      return h.messageParams = e, h;
    }, h.prototype._createPendingMultipleFilesMessage = function (e, t, n) {
      var r = o(s(s({}, this._createPendingSendableMessagePayload(e, t, n)), {
          type: N.FILE
        })),
        i = new ie(this._iid, r);
      return i.messageParams = e, i;
    }, h.prototype._createPendingScheduledFileMessage = function (e, t, n) {
      var r = this._createPendingFileMessage(e, t, n);
      return r.scheduledInfo = {
        scheduledMessageId: 0,
        scheduledAt: e.scheduledAt,
        scheduledMessageParams: e
      }, r;
    }, h.prototype._markMessageAsFailed = function (e, t, n) {
      void 0 === n && (n = !1), e.errorCode = t.code, t.code === F.REQUEST_CANCELED ? e.sendingStatus = O.CANCELED : n || (e.sendingStatus = O.FAILED);
    }, h.prototype.sendUserMessage = function (e) {
      var t = s(s({}, Ae), e);
      return k(De(t)).throw(_.invalidParameters), this._sendUserMessage(t);
    }, h.prototype._sendUserMessage = function (e, t) {
      var n = this,
        r = T.of(this._iid),
        i = r.dispatcher,
        a = r.requestQueue;
      r.sessionManager;
      var o = null != t ? t : this._generateRequestId(),
        u = Date.now(),
        c = new oe();
      return Q(2).then(function () {
        var t = new xt(s(s({}, e), {
          channelUrl: n.url,
          channelType: n.channelType,
          reqId: o
        }));
        a.send(t).then(function (e) {
          var t = e.as(Gt).message;
          i.dispatch(new z({
            messages: [t],
            source: x.EVENT_MESSAGE_SENT_SUCCESS
          })), G(function () {
            return v(n, void 0, void 0, function () {
              return g(this, function (e) {
                return [2, c._trigger(null, t)];
              });
            });
          });
        }).catch(function (t) {
          if (V(t)) throw t;
          var r = n._createPendingUserMessage(e, o, u),
            a = T.of(n._iid).cacheContext.localCacheEnabled && j(t.code);
          n._markMessageAsFailed(r, t, a), i.dispatch(new z({
            messages: [r],
            source: r.sendingStatus === O.PENDING ? x.REQUEST_RESEND_MESSAGE : x.EVENT_MESSAGE_SENT_FAILED
          })), G(function () {
            return v(n, void 0, void 0, function () {
              return g(this, function (e) {
                return [2, c._trigger(t, r)];
              });
            });
          });
        });
        var r = n._createPendingUserMessage(e, o, u);
        i.dispatch(new z({
          messages: [r],
          source: x.EVENT_MESSAGE_SENT_PENDING
        })), G(function () {
          return v(n, void 0, void 0, function () {
            return g(this, function (e) {
              return [2, c._trigger(null, r)];
            });
          });
        });
      }), c;
    }, h.prototype._autoResendUserMessage = function (e) {
      return k(e instanceof Z && !!e.messageParams).throw(_.invalidParameters), this._sendUserMessage(e.messageParams, e.reqId);
    }, h.prototype.resendUserMessage = function (e) {
      var t;
      return v(this, void 0, void 0, function () {
        var n, r;
        return g(this, function (i) {
          return k(e instanceof Z && !e.scheduledInfo).throw(_.invalidParameters), n = new H(), r = null !== (t = e.messageParams) && void 0 !== t ? t : function (e) {
            var t;
            return o(u({
              data: e.data,
              customType: e.customType,
              mentionType: e.mentionType,
              mentionedUsers: e.mentionedUsers,
              mentionedUserIds: e.mentionedUserIds,
              mentionedMessageTemplate: e.mentionedMessageTemplate,
              metaArrays: e.metaArrays,
              pollId: null === (t = e.poll) || void 0 === t ? void 0 : t.id,
              parentMessageId: e.parentMessageId,
              appleCriticalAlertOptions: e.appleCriticalAlertOptions,
              message: e.message,
              translationTargetLanguages: Object.keys(e.translations)
            }));
          }(e), this._sendUserMessage(r, e.reqId).onFailed(function (e) {
            return n.reject(e);
          }).onSucceeded(function (e) {
            return n.resolve(e);
          }), [2, n.promise];
        });
      });
    }, h.prototype.updateUserMessage = function (e, n) {
      return v(this, void 0, void 0, function () {
        var r, i, a, o;
        return g(this, function (u) {
          switch (u.label) {
            case 0:
              return r = s(s({}, We), n), k(t("number", e) && Ke(r)).throw(_.invalidParameters), i = T.of(this._iid).requestQueue, a = new Vt(s({
                channelType: this.channelType,
                channelUrl: this.url,
                messageId: e
              }, r)), [4, i.send(a)];
            case 1:
              return o = u.sent(), [2, o.as(jt).message];
          }
        });
      });
    }, h.prototype.copyUserMessage = function (e, t) {
      var n, r, i;
      return v(this, void 0, void 0, function () {
        var o, c;
        return g(this, function (l) {
          return k(e instanceof h && t instanceof Z && t.sendingStatus === O.SUCCEEDED && this.url === t.channelUrl && !t.scheduledInfo).throw(_.invalidParameters), k(!t.poll).throw(_.notSupportedError), o = new H(), c = null !== (n = t.messageParams) && void 0 !== n ? n : u(s(s({}, t), {
            mentionType: t.mentionType,
            mentionedUserIds: null !== (r = t.mentionedUserIds) && void 0 !== r ? r : null === (i = t.mentionedUsers) || void 0 === i ? void 0 : i.map(function (e) {
              return e.userId;
            }),
            translationTargetLanguages: Object.keys(t.translations),
            pushNotificationDeliveryOption: a.DEFAULT,
            parentMessageId: null,
            isReplyToChannel: !1,
            isPinnedMessage: !1
          })), e._sendUserMessage(c).onSucceeded(function (e) {
            o.resolve(e);
          }).onFailed(function (e) {
            return o.reject(e);
          }), [2, o.promise];
        });
      });
    }, h.prototype.translateUserMessage = function (e, t) {
      return v(this, void 0, void 0, function () {
        var n, i, a;
        return g(this, function (s) {
          switch (s.label) {
            case 0:
              return k(e instanceof Z && e.messageId > 0 && r("string", t)).throw(_.invalidParameters), n = T.of(this._iid).requestQueue, i = new $t({
                channelType: this.channelType,
                channelUrl: this.url,
                messageId: e.messageId,
                translationTargetLanguages: t
              }), [4, n.send(i)];
            case 1:
              return a = s.sent(), [2, a.as(en).message];
          }
        });
      });
    }, h.prototype._createScheduledUserMessage = function (e, t) {
      var n = this,
        r = T.of(this._iid).requestQueue,
        i = Date.now(),
        a = this._generateRequestId();
      Q(2).then(function () {
        var r = n._createPendingScheduledUserMessage(e, a, i);
        G(function () {
          return v(n, void 0, void 0, function () {
            return g(this, function (e) {
              return [2, t._trigger(null, r)];
            });
          });
        });
      });
      var o = new tn(s({
        reqId: a,
        channelType: this.channelType,
        channelUrl: this.url
      }, e));
      r.send(o).then(function (e) {
        var r = e.as(nn).message;
        G(function () {
          return v(n, void 0, void 0, function () {
            return g(this, function (e) {
              return [2, t._trigger(null, r)];
            });
          });
        });
      }).catch(function (r) {
        if (V(r)) throw r;
        Q(2).then(function () {
          var s = n._createPendingScheduledUserMessage(e, a, i);
          n._markMessageAsFailed(s, r), G(function () {
            return v(n, void 0, void 0, function () {
              return g(this, function (e) {
                return [2, t._trigger(r, s)];
              });
            });
          });
        });
      });
    }, h.prototype.sendFileMessage = function (e) {
      var t = s(s({}, Ne), e);
      return k(Fe(t)).throw(_.invalidParameters), this._sendFileMessage(t);
    }, h.prototype.sendMultipleFilesMessage = function (e) {
      var t,
        n = s(s({}, Qe), e),
        r = T.of(this._iid);
      k(function (e, t) {
        return void 0 === t && (t = l), Pe(e) && Array.isArray(e.fileInfoList) && e.fileInfoList.length >= 2 && e.fileInfoList.length <= t && e.fileInfoList.every(function (e) {
          return ze(e);
        });
      }(n, null === (t = r.appInfo) || void 0 === t ? void 0 : t.multipleFilesMessageFileCountLimit)).throw(_.invalidParameters);
      var i = !!e.fileInfoList.find(function (e) {
        var t = r.appInfo.uploadSizeLimit;
        return e.file instanceof Blob && e.file.size > t || e.fileSize > t;
      });
      return k(!i).throw(_.fileSizeLimitExceededError), this._sendMultipleFilesMessage(n);
    }, h.prototype._sendFileMessage = function (e, t) {
      var n = this,
        r = T.of(this._iid),
        i = r.dispatcher;
      r.sessionManager;
      var a = ae.of(this._iid).fileMessageQueue,
        s = null != t ? t : this._generateRequestId(),
        o = Date.now(),
        u = new oe();
      return Q(2).then(function () {
        var t = n._createPendingFileMessage(e, s, o);
        i.dispatch(new z({
          messages: [t],
          source: x.EVENT_MESSAGE_SENT_PENDING
        })), G(function () {
          return v(n, void 0, void 0, function () {
            return g(this, function (e) {
              return [2, u._trigger(null, t)];
            });
          });
        }), a.request(n, s, e).then(function (e) {
          i.dispatch(new z({
            messages: [e],
            source: x.EVENT_MESSAGE_SENT_SUCCESS
          })), G(function () {
            return v(n, void 0, void 0, function () {
              return g(this, function (t) {
                return [2, u._trigger(null, e)];
              });
            });
          });
        }).catch(function (t) {
          if (V(t)) throw t;
          var r = n._createPendingFileMessage(e, s, o),
            a = T.of(n._iid).cacheContext.localCacheEnabled && j(t.code);
          n._markMessageAsFailed(r, t, a), i.dispatch(new z({
            messages: [r],
            source: r.sendingStatus === O.PENDING ? x.REQUEST_RESEND_MESSAGE : x.EVENT_MESSAGE_SENT_FAILED
          })), G(function () {
            return v(n, void 0, void 0, function () {
              return g(this, function (e) {
                return [2, u._trigger(t, r)];
              });
            });
          });
        });
      }), u;
    }, h.prototype._autoResendFileMessage = function (e) {
      k(e instanceof $ && !!e.messageParams).throw(_.invalidParameters);
      var t = T.of(this._iid).logger;
      return t.debug("autoResendFileMessage pending", e), this._sendFileMessage(e.messageParams, e.reqId).onFailed(function (e) {
        t.debug("autoResendFileMessage failed", e);
      }).onSucceeded(function (e) {
        t.debug("autoResendFileMessage success", e);
      });
    }, h.prototype._sendMultipleFilesMessage = function (e, t) {
      var n = this,
        r = T.of(this._iid),
        i = r.dispatcher;
      r.sessionManager;
      var a = ae.of(this._iid).fileMessageQueue,
        s = null != t ? t : this._generateRequestId(),
        o = Date.now(),
        u = new se();
      return Q(2).then(function () {
        var t = n._createPendingMultipleFilesMessage(e, s, o);
        i.dispatch(new z({
          messages: [t],
          source: x.EVENT_MESSAGE_SENT_PENDING
        })), G(function () {
          return v(n, void 0, void 0, function () {
            return g(this, function (e) {
              return [2, u._trigger(null, t)];
            });
          });
        }), a.request(n, s, e, u).then(function (e) {
          i.dispatch(new z({
            messages: [e],
            source: x.EVENT_MESSAGE_SENT_SUCCESS
          })), G(function () {
            return v(n, void 0, void 0, function () {
              return g(this, function (t) {
                return [2, u._trigger(null, e)];
              });
            });
          });
        }).catch(function (t) {
          if (V(t)) throw t;
          var r = n._createPendingMultipleFilesMessage(e, s, o);
          n._markMessageAsFailed(r, t), i.dispatch(new z({
            messages: [r],
            source: x.EVENT_MESSAGE_SENT_FAILED
          })), G(function () {
            return v(n, void 0, void 0, function () {
              return g(this, function (e) {
                return [2, u._trigger(t, r)];
              });
            });
          });
        });
      }), u;
    }, h.prototype._createScheduledFileMessage = function (e, t, n, r) {
      var i = this,
        a = T.of(this._iid).requestQueue,
        o = new rn(s(s({
          reqId: n,
          channelType: this.channelType,
          channelUrl: this.url
        }, e), {
          fileUrl: e.fileUrl,
          requireAuth: e.requireAuth
        }));
      a.send(o).then(function (e) {
        var n = e.as(an).message;
        G(function () {
          return v(i, void 0, void 0, function () {
            return g(this, function (e) {
              return [2, t._trigger(null, n)];
            });
          });
        });
      }).catch(function (a) {
        if (V(a)) throw a;
        Q(2).then(function () {
          var s = i._createPendingScheduledFileMessage(e, n, r);
          i._markMessageAsFailed(s, a), G(function () {
            return v(i, void 0, void 0, function () {
              return g(this, function (e) {
                return [2, t._trigger(a, s)];
              });
            });
          });
        });
      });
    }, h.prototype.sendFileMessages = function (e) {
      var t, n;
      k(e.every(function (e) {
        return Fe(s(s({}, Ne), e));
      })).throw(_.invalidParameters);
      var r = new oe();
      try {
        for (var i = L(e), a = i.next(); !a.done; a = i.next()) {
          var o = a.value;
          this.sendFileMessage(o).onPending(function (e) {
            return r._trigger(null, e);
          }).onFailed(function (e, t) {
            return r._trigger(e, t);
          }).onSucceeded(function (e) {
            return r._trigger(null, e);
          });
        }
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          a && !a.done && (n = i.return) && n.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return r;
    }, h.prototype.resendFileMessage = function (e, t) {
      var n;
      return v(this, void 0, void 0, function () {
        var r, i, a;
        return g(this, function (s) {
          return r = Boolean(e.url) || c(t) || c(null === (n = e.messageParams) || void 0 === n ? void 0 : n.file), k(e instanceof $ && r && !e.scheduledInfo).throw(_.invalidParameters), i = new H(), a = function (e, t) {
            var n;
            return e.messageParams ? (!e.url && c(t) && (e.messageParams.file = t), e.messageParams) : o(u({
              data: e.data,
              customType: e.customType,
              mentionType: e.mentionType,
              mentionedUsers: e.mentionedUsers,
              mentionedUserIds: e.mentionedUserIds,
              metaArrays: e.metaArrays,
              parentMessageId: e.parentMessageId,
              appleCriticalAlertOptions: e.appleCriticalAlertOptions,
              file: t,
              fileUrl: e.url,
              fileName: e.name,
              fileSize: e.size,
              mimeType: e.type,
              thumbnailSizes: null === (n = e.thumbnails) || void 0 === n ? void 0 : n.map(function (e) {
                return {
                  maxWidth: e.width,
                  maxHeight: e.height
                };
              })
            }));
          }(e, t), this._sendFileMessage(a, e.reqId).onFailed(function (e) {
            return i.reject(e);
          }).onSucceeded(function (e) {
            return i.resolve(e);
          }), [2, i.promise];
        });
      });
    }, h.prototype.updateFileMessage = function (e, n) {
      return v(this, void 0, void 0, function () {
        var r, i, a, o;
        return g(this, function (u) {
          switch (u.label) {
            case 0:
              return r = s(s({}, He), n), k(t("number", e) && function (e) {
                return Be(e);
              }(r)).throw(_.invalidParameters), i = T.of(this._iid).requestQueue, a = new Bt(s({
                channelType: this.channelType,
                channelUrl: this.url,
                messageId: e
              }, r)), [4, i.send(a)];
            case 1:
              return o = u.sent(), [2, o.as(Wt).message];
          }
        });
      });
    }, h.prototype.cancelUploadingFileMessage = function (e) {
      return v(this, void 0, void 0, function () {
        return g(this, function (n) {
          return k(t("string", e)).throw(_.invalidParameters), ae.of(this._iid).fileMessageQueue.cancel(this, e), [2, !0];
        });
      });
    }, h.prototype.copyFileMessage = function (e, t) {
      var n, r, i;
      return v(this, void 0, void 0, function () {
        var o, c;
        return g(this, function (l) {
          return k(e instanceof h && t instanceof $ && t.sendingStatus === O.SUCCEEDED && this.url === t.channelUrl && !t.scheduledInfo).throw(_.invalidParameters), o = new H(), c = u(s(s({}, t), {
            fileUrl: t.url,
            fileName: t.name,
            fileSize: t.size,
            mimeType: t.type,
            mentionType: t.mentionType,
            mentionedUserIds: null !== (n = t.mentionedUserIds) && void 0 !== n ? n : null === (r = t.mentionedUsers) || void 0 === r ? void 0 : r.map(function (e) {
              return e.userId;
            }),
            pushNotificationDeliveryOption: a.DEFAULT,
            parentMessageId: null,
            isReplyToChannel: !1,
            thumbnailSizes: null === (i = t.thumbnails) || void 0 === i ? void 0 : i.map(function (e) {
              return {
                maxWidth: e.width,
                maxHeight: e.height
              };
            }),
            requireAuth: t.requireAuth,
            isPinnedMessage: !1
          })), e._sendFileMessage(c).onSucceeded(function (e) {
            return o.resolve(e);
          }).onFailed(function (e) {
            return o.reject(e);
          }), [2, o.promise];
        });
      });
    }, h.prototype.deleteMessage = function (e) {
      return v(this, void 0, void 0, function () {
        var t, n;
        return g(this, function (r) {
          switch (r.label) {
            case 0:
              return k(e instanceof he).throw(_.invalidParameters), e.messageId > 0 ? (t = T.of(this._iid).requestQueue, n = new Kt({
                channelType: this.channelType,
                channelUrl: this.url,
                messageId: e.messageId
              }), [4, t.send(n)]) : [3, 2];
            case 1:
              r.sent(), r.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, h.prototype.addReaction = function (e, n) {
      return v(this, void 0, void 0, function () {
        var r, i, a;
        return g(this, function (s) {
          switch (s.label) {
            case 0:
              return k(e instanceof he && e.messageId > 0 && t("string", n)).throw(_.invalidParameters), r = T.of(this._iid).requestQueue, i = new Yt({
                channelType: this.channelType,
                channelUrl: this.url,
                messageId: e.messageId,
                reactionKey: n
              }), [4, r.send(i)];
            case 1:
              return a = s.sent(), [2, a.as(Jt).reactionEvent];
          }
        });
      });
    }, h.prototype.deleteReaction = function (e, n) {
      return v(this, void 0, void 0, function () {
        var r, i, a;
        return g(this, function (s) {
          switch (s.label) {
            case 0:
              return k(e instanceof he && e.messageId > 0 && t("string", n)).throw(_.invalidParameters), r = T.of(this._iid).requestQueue, i = new Xt({
                channelType: this.channelType,
                channelUrl: this.url,
                messageId: e.messageId,
                reactionKey: n
              }), [4, r.send(i)];
            case 1:
              return a = s.sent(), [2, a.as(Zt).reactionEvent];
          }
        });
      });
    }, h.prototype._updateUserMessageMetaArray = function (e, t, n, r) {
      return v(this, void 0, void 0, function () {
        var i, a, s, o, u, c;
        return g(this, function (l) {
          switch (l.label) {
            case 0:
              return i = T.of(this._iid), a = i.dispatcher, s = i.requestQueue, o = new Vt({
                channelType: this.channelType,
                channelUrl: this.url,
                messageId: e,
                metaArrayParams: {
                  array: t,
                  mode: n,
                  upsert: r
                }
              }), [4, s.send(o)];
            case 1:
              return u = l.sent(), c = u.as(jt).message, a.dispatch(new z({
                messages: [c],
                source: x.EVENT_MESSAGE_UPDATED
              })), [2, c];
          }
        });
      });
    }, h.prototype._updateFileMessageMetaArray = function (e, t, n, r) {
      return v(this, void 0, void 0, function () {
        var i, a, s, o, u, c;
        return g(this, function (l) {
          switch (l.label) {
            case 0:
              return i = T.of(this._iid), a = i.dispatcher, s = i.requestQueue, o = new Bt({
                channelType: this.channelType,
                channelUrl: this.url,
                messageId: e,
                metaArrayParams: {
                  array: t,
                  mode: n,
                  upsert: r
                }
              }), [4, s.send(o)];
            case 1:
              return u = l.sent(), c = u.as(Wt).message, a.dispatch(new z({
                messages: [c],
                source: x.EVENT_MESSAGE_UPDATED
              })), [2, c];
          }
        });
      });
    }, h.prototype.createMessageMetaArrayKeys = function (e, t) {
      return v(this, void 0, void 0, function () {
        var n;
        return g(this, function (i) {
          return k(e instanceof he && e.messageId > 0 && r("string", t)).throw(_.invalidParameters), n = t.map(function (e) {
            return new J({
              key: e
            });
          }), e instanceof $ ? [2, this._updateFileMessageMetaArray(e.messageId, n, "add", !0)] : [2, this._updateUserMessageMetaArray(e.messageId, n, "add", !0)];
        });
      });
    }, h.prototype.deleteMessageMetaArrayKeys = function (e, t) {
      return v(this, void 0, void 0, function () {
        var n;
        return g(this, function (i) {
          return k(e instanceof he && e.messageId > 0 && r("string", t)).throw(_.invalidParameters), n = t.map(function (e) {
            return new J({
              key: e
            });
          }), e instanceof $ ? [2, this._updateFileMessageMetaArray(e.messageId, n, "remove", !0)] : [2, this._updateUserMessageMetaArray(e.messageId, n, "remove", !0)];
        });
      });
    }, h.prototype.addMessageMetaArrayValues = function (e, t) {
      return v(this, void 0, void 0, function () {
        return g(this, function (n) {
          return k(e instanceof he && e.messageId > 0 && t.every(function (e) {
            return e instanceof J;
          })).throw(_.invalidParameters), e instanceof $ ? [2, this._updateFileMessageMetaArray(e.messageId, t, "add", !0)] : [2, this._updateUserMessageMetaArray(e.messageId, t, "add", !0)];
        });
      });
    }, h.prototype.removeMessageMetaArrayValues = function (e, t) {
      return v(this, void 0, void 0, function () {
        return g(this, function (n) {
          return k(e instanceof he && e.messageId > 0 && t.every(function (e) {
            return e instanceof J;
          })).throw(_.invalidParameters), e instanceof $ ? [2, this._updateFileMessageMetaArray(e.messageId, t, "remove", !0)] : [2, this._updateUserMessageMetaArray(e.messageId, t, "remove", !0)];
        });
      });
    }, h.prototype.report = function (e, r) {
      return v(this, void 0, void 0, function () {
        var i, a, s, o;
        return g(this, function (u) {
          switch (u.label) {
            case 0:
              return k(n(xe, e) && t("string", r)).throw(_.invalidParameters), i = T.of(this._iid), a = i.sdkState, s = i.requestQueue, o = new kt({
                channelUrl: this.url,
                channelType: this.channelType,
                userId: a.userId,
                category: e,
                description: r
              }), [4, s.send(o)];
            case 1:
              return u.sent(), [2];
          }
        });
      });
    }, h.prototype.reportUser = function (e, r, a) {
      return v(this, void 0, void 0, function () {
        var s, o, u, c;
        return g(this, function (l) {
          switch (l.label) {
            case 0:
              return k(e instanceof i && n(xe, r) && t("string", a)).throw(_.invalidParameters), s = T.of(this._iid), o = s.sdkState, u = s.requestQueue, c = new Qt({
                channelUrl: this.url,
                channelType: this.channelType,
                userId: o.userId,
                offendingUserId: e.userId,
                category: r,
                description: a
              }), [4, u.send(c)];
            case 1:
              return l.sent(), [2];
          }
        });
      });
    }, h.prototype.reportMessage = function (e, r, i) {
      return v(this, void 0, void 0, function () {
        var a, s, o, u;
        return g(this, function (c) {
          switch (c.label) {
            case 0:
              return k(e instanceof pe && n(xe, r) && t("string", i)).throw(_.invalidParameters), a = T.of(this._iid), s = a.sdkState, o = a.requestQueue, u = new zt({
                channelUrl: this.url,
                channelType: this.channelType,
                userId: s.userId,
                offendingUserId: e.sender.userId,
                messageId: e.messageId,
                category: r,
                description: i
              }), [4, o.send(u)];
            case 1:
              return c.sent(), [2];
          }
        });
      });
    }, h.prototype.updatePoll = function (e, n) {
      return v(this, void 0, void 0, function () {
        var r, i, a;
        return g(this, function (o) {
          switch (o.label) {
            case 0:
              return k(t("number", e) && function (e) {
                return t("string", e.title, !0) && C(e.data) && t("boolean", e.allowUserSuggestion, !0) && t("boolean", e.allowMultipleVotes, !0) && t("number", e.closeAt, !0);
              }(n)).throw(_.invalidParameters), r = T.of(this._iid).requestQueue, i = new sn(s({
                pollId: e
              }, n)), [4, r.send(i)];
            case 1:
              return a = o.sent(), [2, a.as(on).poll];
          }
        });
      });
    }, h.prototype.deletePoll = function (e) {
      return v(this, void 0, void 0, function () {
        var n, r, i;
        return g(this, function (a) {
          switch (a.label) {
            case 0:
              return n = t("number", e), k(n).throw(_.invalidParameters), r = T.of(this._iid).requestQueue, i = new un({
                pollId: e
              }), [4, r.send(i)];
            case 1:
              return a.sent(), [2];
          }
        });
      });
    }, h.prototype.closePoll = function (e) {
      return v(this, void 0, void 0, function () {
        var n, r, i, a;
        return g(this, function (s) {
          switch (s.label) {
            case 0:
              return n = t("number", e), k(n).throw(_.invalidParameters), r = T.of(this._iid).requestQueue, i = new cn({
                pollId: e
              }), [4, r.send(i)];
            case 1:
              return a = s.sent(), [2, a.as(ln).poll];
          }
        });
      });
    }, h.prototype.addPollOption = function (e, n) {
      return v(this, void 0, void 0, function () {
        var r, i, a, s;
        return g(this, function (o) {
          switch (o.label) {
            case 0:
              return r = t("number", e) && t("string", n) && "" !== n.trim(), k(r).throw(_.invalidParameters), i = T.of(this._iid).requestQueue, a = new dn({
                channelUrl: this.url,
                channelType: this.channelType,
                pollId: e,
                optionText: n
              }), [4, i.send(a)];
            case 1:
              return s = o.sent(), [2, s.as(hn).poll];
          }
        });
      });
    }, h.prototype.updatePollOption = function (e, n, r) {
      return v(this, void 0, void 0, function () {
        var i, a, s, o;
        return g(this, function (u) {
          switch (u.label) {
            case 0:
              return i = t("number", e) && t("number", n) && t("string", r) && "" !== r.trim(), k(i).throw(_.invalidParameters), a = T.of(this._iid).requestQueue, s = new pn({
                pollId: e,
                pollOptionId: n,
                optionText: r
              }), [4, a.send(s)];
            case 1:
              return o = u.sent(), [2, o.as(fn).poll];
          }
        });
      });
    }, h.prototype.deletePollOption = function (e, n) {
      return v(this, void 0, void 0, function () {
        var r, i, a;
        return g(this, function (s) {
          switch (s.label) {
            case 0:
              return r = t("number", e) && t("number", n), k(r).throw(_.invalidParameters), i = T.of(this._iid).requestQueue, a = new mn({
                pollId: e,
                pollOptionId: n
              }), [4, i.send(a)];
            case 1:
              return s.sent(), [2];
          }
        });
      });
    }, h.prototype.votePoll = function (e, n) {
      return v(this, void 0, void 0, function () {
        var i, a, s, o, u, c, l;
        return g(this, function (d) {
          switch (d.label) {
            case 0:
              return i = t("number", e) && r("number", n), k(i).throw(_.invalidParameters), a = T.of(this._iid), s = a.requestQueue, o = a.dispatcher, u = new vn({
                reqId: this._generateRequestId(),
                channelUrl: this.url,
                channelType: this.channelType,
                pollId: e,
                pollOptionIds: n
              }), [4, s.send(u)];
            case 1:
              return c = d.sent(), l = c.as(yn).event, o.dispatch(new Y({
                event: l,
                source: x.EVENT_POLL_VOTED
              })), [2, l];
          }
        });
      });
    }, h.prototype.getPollChangeLogsSinceTimestamp = function (e) {
      return v(this, void 0, void 0, function () {
        return g(this, function (n) {
          switch (n.label) {
            case 0:
              return k(t("number", e)).throw(_.invalidParameters), [4, ye.of(this._iid).getPollChangeLogs(this.url, this.channelType, e)];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, h.prototype.getPollChangeLogsSinceToken = function (e) {
      return v(this, void 0, void 0, function () {
        return g(this, function (n) {
          switch (n.label) {
            case 0:
              return k(t("string", e, !0)), [4, ye.of(this._iid).getPollChangeLogs(this.url, this.channelType, e)];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, h.prototype.createPollListQuery = function (e) {
      return void 0 === e && (e = 10), new me(this._iid, {
        channelUrl: this.url,
        channelType: this.channelType,
        limit: e
      });
    }, h.prototype.createPollVoterListQuery = function (e, t, n) {
      return void 0 === n && (n = 20), new ve(this._iid, {
        channelUrl: this.url,
        channelType: this.channelType,
        pollId: e,
        pollOptionId: t,
        limit: n
      });
    }, h;
  }(B);
export { jt as A, rt as B, Wt as C, Ie as D, Gt as E, ge as F, je as G, Be as H, We as I, Ke as J, nn as K, gn as L, et as M, Te as N, Xe as O, yn as P, xe as R, Ae as U, Ue as a, we as b, Me as c, Ee as d, be as e, _n as f, Ve as g, Ge as h, Re as i, Se as j, Le as k, Pe as l, ke as m, Oe as n, qe as o, _e as p, Et as q, ft as r, Ce as s, Ft as t, Lt as u, De as v, qt as w, Ct as x, Dt as y, Ht as z };